import type { IHilSubmitClient, HilSubmitResult } from '../writer/IHilSubmitClient';
import type { HilPresentationReplyEnvelope } from '@bizfirst/hil-types';

export class DevMockHilSubmitClient implements IHilSubmitClient {
  private delayMs: number;

  constructor(delayMs = 400) {
    this.delayMs = delayMs;
  }

  async post(url: string, envelope: HilPresentationReplyEnvelope): Promise<HilSubmitResult> {
    console.info('[HIL Dev Mock] post() called — no real HTTP request made.', { url, envelope });
    await new Promise<void>((res) => setTimeout(res, this.delayMs));
    return { ok: true };
  }
}
